import { memo } from 'react';

import { ShareBrandContextRow } from '~/components/ShareModal/components/ShareBrandContextRow';
import { ShareModalSectionLabel } from '~/components/ShareModal/components/ShareModalSectionLabel';
import { useShareBoardDesign } from '~/components/SharePrivateBoardModal/ShareBoardDesignProvider';

/** Brand-context picker section: binds the presentational row to the board design context. */
export const ShareBoardDesignBrandContextSection = memo(() => {
  const { brandingDisabled, brandCustomizationEnabled, selectedContextSourceId, handleSelectBrandContext } =
    useShareBoardDesign();

  return (
    <div className="flex flex-col gap-1">
      <ShareModalSectionLabel title="Brand Context" />
      <ShareBrandContextRow
        data-testid="SHARE_BOARD_DESIGN_BRAND_CONTEXT_ROW"
        disabled={brandingDisabled}
        onSelectContextSource={handleSelectBrandContext}
        selectedContextSourceId={selectedContextSourceId}
        // Plan-gate-only: keep controls disabled during in-flight saves (above), but the upsell
        // affordance must reflect ONLY the plan gate so it doesn't flash on every save.
        showUpsell={!brandCustomizationEnabled}
      />
    </div>
  );
});

ShareBoardDesignBrandContextSection.displayName = 'ShareBoardDesignBrandContextSection';
